import a from './Avatar.module.css';
import { solidTint } from './tint';
import { VectorAvatar } from './VectorAvatar';

type Look = { photo: string } | { vector: number };

/**
 * The landing's sample people. The portraits are generated for this prototype; they are not
 * real people. They live in public/ (not imported), so they stay out of the precached shell.
 */
const LOOKS: Record<string, Look> = {
  Anna: { photo: '/landing/avatars/anna.webp' },
  Alex: { photo: '/landing/avatars/tomek.webp' },
  Mom: { photo: '/landing/avatars/mum.webp' },
  Maya: { vector: 1 },
};

/**
 * A member's face: a photo, an illustrated face, or (anyone else) the launcher's initial on the
 * member's tint. The tint and initial sit under a photo until it loads. Size it with `className`.
 */
export function Avatar({ name, className }: { name: string; className?: string }) {
  const look = LOOKS[name];
  return (
    <span className={className ? `${a.avatar} ${className}` : a.avatar} style={solidTint(name, 1.5)} aria-hidden>
      {look && 'vector' in look ? (
        <VectorAvatar name={name} seed={look.vector} />
      ) : (
        <svg viewBox="0 0 40 40" width="100%" height="100%">
          <text x="20" y="21" textAnchor="middle" dominantBaseline="central" className={a.initial}>
            {(Array.from(name.trim())[0] ?? '?').toUpperCase()}
          </text>
        </svg>
      )}
      {look && 'photo' in look && <img src={look.photo} width={192} height={192} loading="lazy" decoding="async" alt="" />}
    </span>
  );
}
